import LaboratoryRepository from '../repositories/LaboratoryRepository';

export interface Specialty {
  id: string;
  name: string;
  iconName?: string;
}
export interface ILaboratory {
  id: string | number;
  name: string;
  address: string;
  latlng: string;
  distance?: number;
  photo?: string | null;
  timetable?: string | null;
  specific_analyses?: string | null;
  pricing?: string | null;
  payment_methods?: string | null;
  languages?: string | null;
  biologists?: string | null;
  accessibility?: string | null;
  at_home?: string | null;
  external_link?: string | null;
  phone?: string | null;
  appointment_type: 'all' | 'direct_only' | 'appointment_only' | 'none';
  covid: boolean;
  selasId: string;
  available_results: string[];
  confirmation_message?: string;
  prescription_title?: string;
  prescription_description?: string;
  prescription_message?: string;
  prescription_popup?: string;
  registration_options?: {
    mutual_required: boolean;
    certificate_reimbursement: boolean;
    no_nir: boolean;
  };
  checkin_welcome_message?: string;
  slug?: string | null;
  checkin_forms: 'hormonology'[];
  specialities: Specialty[];
}

export default class Laboratory implements ILaboratory {
  id: string | number;
  name: string;
  address: string;
  latlng: string;
  distance: number;
  photo: string | null;
  timetable: string | null;
  specific_analyses: string | null;
  pricing: string | null;
  payment_methods: string | null;
  languages: string | null;
  biologists: string | null;
  accessibility: string | null;
  at_home: string | null;
  external_link: string | null;
  phone: string | null;
  appointment_type: ILaboratory['appointment_type'];
  covid: boolean;
  selasId: string;
  available_results: string[];
  confirmation_message?: string;
  prescription_title?: ILaboratory['prescription_title'];
  prescription_description?: ILaboratory['prescription_description'];
  prescription_message: ILaboratory['prescription_message'];
  prescription_popup: ILaboratory['prescription_popup'];
  registration_options: ILaboratory['registration_options'];
  checkin_welcome_message: ILaboratory['checkin_welcome_message'];
  slug: string | null;
  checkin_forms: ILaboratory['checkin_forms'];
  specialities: ILaboratory['specialities'];

  constructor({
    id,
    name,
    address,
    latlng,
    distance = 0,
    photo = null,
    timetable = null,
    specific_analyses = null,
    pricing = null,
    payment_methods = null,
    languages = null,
    biologists = null,
    accessibility = null,
    at_home = null,
    external_link = null,
    phone = null,
    appointment_type = 'none',
    covid = false,
    selasId,
    available_results = [],
    confirmation_message,
    prescription_title,
    prescription_description,
    prescription_message,
    prescription_popup,
    registration_options,
    checkin_welcome_message,
    slug = null,
    checkin_forms = [],
    specialities = []
  }: ILaboratory) {
    this.id = id;
    this.name = name;
    this.address = address;
    this.latlng = latlng;
    this.distance = distance;
    this.photo = photo;
    this.timetable = timetable;
    this.specific_analyses = specific_analyses;
    this.pricing = pricing;
    this.payment_methods = payment_methods;
    this.languages = languages;
    this.biologists = biologists;
    this.accessibility = accessibility;
    this.at_home = at_home;
    this.external_link = external_link;
    this.phone = phone;
    this.appointment_type = appointment_type;
    this.covid = !!covid;
    this.selasId = selasId;
    this.available_results = available_results;
    this.confirmation_message = confirmation_message;
    this.prescription_title = prescription_title;
    this.prescription_description = prescription_description;
    this.prescription_message = prescription_message;
    this.prescription_popup = prescription_popup;
    this.registration_options = {
      mutual_required: !!registration_options?.mutual_required,
      certificate_reimbursement:
        !!registration_options?.certificate_reimbursement,
      no_nir: !!registration_options?.no_nir
    };
    this.checkin_welcome_message = checkin_welcome_message;
    this.slug = slug;
    this.checkin_forms = checkin_forms;
    this.specialities = specialities;
  }

  async getSlots() {
    return await LaboratoryRepository.getSlotsByLaboratory(this);
  }
}
